<div class="nav-item" [hidden]="(isVisible$ | async) === false">
    <div class="btn-group">
        <button class="btn rounded-0 hs-toolbar-button btn-light btn-outline-secondary"
            [title]="'TOOLBAR.measureLinesAndPolygon' | translateHs" (click)="measureButtonClicked()">
            <i class="icon-design"></i>
        </button>
    </div>
</div>